export default __webpack_public_path__ + "static/media/send-message.e544c335.svg";